import { RootState } from "../store/store";
import { Snapshot } from "@etechinc/smartview-core";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MapState {
  sceneReady: boolean;
  snapshot?: Snapshot;
}

const initialState = {
  sceneReady: false,
  snapshot: undefined,
} as MapState;

const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    setMapSceneReady: (state, { payload }: PayloadAction<boolean>) => {
      state.sceneReady = payload;
    },
    setMapSnapshot: (state, { payload }: PayloadAction<Snapshot | undefined>) => {
      state.snapshot = payload;
    },
  },
});

export const {
  setMapSceneReady,
  setMapSnapshot,
} = mapSlice.actions;

export const mapSceneReadySelector = (state: RootState) => state.map.sceneReady;
export const mapSnapshotSelector = (state: RootState) => state.map.snapshot;

export default mapSlice.reducer;
